/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.sunnahsky.article.draft.defs'

type $nsid = typeof $nsid

export { $nsid }

/** An in-progress article draft. Every field is optional, unlike site.standard.document, since a draft may be incomplete. THIS IS A TEMPORARY UNSPECCED LEXICON, specific to this fork's article-authoring feature. */
type Draft = {
  $type?: 'com.sunnahsky.article.draft.defs#draft'
  title?: string
  description?: string

  /**
   * Raw markdown body text.
   */
  markdown?: string
  flavor?: 'gfm' | 'commonmark' | l.UnknownString
  facets?: l.Unknown$TypedObject[]
  tags?: string[]
  categories?: string[]
  authors?: string[]
  translators?: string[]

  /**
   * Image to use for thumbnail or cover image. Less than 1MB in size.
   */
  coverImage?: l.BlobRef

  /**
   * Blob refs for images embedded in the draft body. Stored here because a BlobRef cannot be reconstructed from the CID in a markdown getBlob URL alone - mimeType and size are unreadable for a blob that was never tethered - so without this the refs would not survive closing the composer, and republishing a reopened draft would silently drop its images. Drafts live in private stash and these blobs stay untethered, so they are not publicly enumerable via com.atproto.sync.listBlobs; they are tethered only at publish, into com.sunnahsky.article.assets.
   */
  bodyImages?: BodyImage[]
}

export type { Draft }

/** An in-progress article draft. Every field is optional, unlike site.standard.document, since a draft may be incomplete. THIS IS A TEMPORARY UNSPECCED LEXICON, specific to this fork's article-authoring feature. */
const draft = /*#__PURE__*/ l.typedObject<Draft>(
  $nsid,
  'draft',
  /*#__PURE__*/ l.object({
    title: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxGraphemes: 500, maxLength: 5000 }),
    ),
    description: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxGraphemes: 3000, maxLength: 30000 }),
    ),
    markdown: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    flavor: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{ knownValues: ['gfm', 'commonmark'] }>(),
    ),
    facets: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.typedUnion([], false)),
    ),
    tags: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.string({ maxGraphemes: 128, maxLength: 1280 }),
      ),
    ),
    categories: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
    ),
    authors: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
    ),
    translators: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.string()),
    ),
    coverImage: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.blob({ accept: ['image/*'], maxSize: 1000000 }),
    ),
    bodyImages: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<BodyImage>((() => bodyImage) as any),
        { maxLength: 30 },
      ),
    ),
  }),
)

export { draft }

/** One image embedded in a draft body: the blob ref that will be tethered at publish, plus the filename to show while the image itself cannot be rendered. */
type BodyImage = {
  $type?: 'com.sunnahsky.article.draft.defs#bodyImage'
  image: l.BlobRef

  /**
   * Original filename as reported by the picker, shown in the composer's placeholder so the author can tell which image sits where while it cannot be displayed. Display only - never used to construct a path or a URL, and absent when the picker reports no filename. Consumers MUST sanitise before rendering: escape as text rather than markup, and strip Unicode bidi controls.
   */
  name?: string
}

export type { BodyImage }

/** One image embedded in a draft body: the blob ref that will be tethered at publish, plus the filename to show while the image itself cannot be rendered. */
const bodyImage = /*#__PURE__*/ l.typedObject<BodyImage>(
  $nsid,
  'bodyImage',
  /*#__PURE__*/ l.object({
    image: /*#__PURE__*/ l.blob({ accept: ['image/*'], maxSize: 3000000 }),
    name: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ maxGraphemes: 255, maxLength: 2550 }),
    ),
  }),
)

export { bodyImage }

type DraftView = {
  $type?: 'com.sunnahsky.article.draft.defs#draftView'

  /**
   * A TID to be used as a draft identifier.
   */
  id: l.TidString
  draft: Draft
  createdAt: l.DatetimeString
  updatedAt: l.DatetimeString
}

export type { DraftView }

const draftView = /*#__PURE__*/ l.typedObject<DraftView>(
  $nsid,
  'draftView',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.string({ format: 'tid' }),
    draft: /*#__PURE__*/ l.ref<Draft>((() => draft) as any),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    updatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { draftView }

/** A draft with an identifier, used to store drafts in private storage (stash). */
type DraftWithId = {
  $type?: 'com.sunnahsky.article.draft.defs#draftWithId'

  /**
   * A TID to be used as a draft identifier.
   */
  id: l.TidString
  draft: Draft
}

export type { DraftWithId }

/** A draft with an identifier, used to store drafts in private storage (stash). */
const draftWithId = /*#__PURE__*/ l.typedObject<DraftWithId>(
  $nsid,
  'draftWithId',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.string({ format: 'tid' }),
    draft: /*#__PURE__*/ l.ref<Draft>((() => draft) as any),
  }),
)

export { draftWithId }
